import reducer, { SiteInfoListObsrecState } from "./reducers";
import * as siteInfoListObsrecOperations from "./operations";
export {
  siteInfoListObsrecOperations,
  SiteInfoListObsrecState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/siteInfoListObsrec/index.ts